import { render, staticRenderFns } from "./RgwChart.vue?vue&type=template&id=3d737da9&scoped=true&"
import script from "./RgwChart.vue?vue&type=script&lang=js&"
export * from "./RgwChart.vue?vue&type=script&lang=js&"
import style0 from "./RgwChart.vue?vue&type=style&index=0&id=3d737da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d737da9",
  null
  
)

export default component.exports